<div id="central-management-app" style="height: 100%">
    <router-outlet (activate)="routedComponent = $event"></router-outlet>
</div>
